import React, { useMemo } from "react";
import ExplorerHeatmap from "./components/ExplorerHeatmap";
import ExplorerTable from "./components/ExplorerTable";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { translate } from "../../../../utilities/Translate";
import "./ECLExplorerBlock.css";

export default function ECLExplorerBlock(props) {
   const instanceID = useSelectorId();
   const explorer = useMemo(() => {
      return (
         <section className="explorer-block">
            <h2>{props.block.data.name}</h2>
            <label htmlFor={"number-table" + instanceID}>
               {translate("Numeric Properties")}
            </label>
            <ExplorerTable
               endpoint="Numeric Properties"
               id={"number-table" + instanceID}
               {...props}
            />
            <label htmlFor={"cat-table" + instanceID}>
               {translate("Categorical Properties")}
            </label>
            <ExplorerTable
               endpoint="Categorical Properties"
               id={"cat-table" + instanceID}
               {...props}
            />
            <label htmlFor={"correlation-matrix" + instanceID}>
               Correlation
            </label>
            <ExplorerHeatmap
               id={"correlation-matrix" + instanceID}
               {...props}
            />
         </section>
      );
   }, [props.block]);

   return explorer;
}
